import { ITEMS_PER_PAGE, SortOrder } from "../../constants/general";

export const CONFIG_MANAGER_ITEMS_PER_PAGE = "10";

export const moduleSlug = "CONFIG_MANAGER";
export const naveeAutoEnforcementCode = "NAVEE_AUTO_ENFORCEMENT";
export const scraperforceSeResultsCode = "SCRAPERFORCE_SE_RESULTS";

export default { moduleSlug };

export const configManagerFields = {
    modified: "_modified",
    created: "_created",
    version: "version",
    workers: "workerOption.count"
};

export const CONFIG_MANAGER_FILTER = {
    offset: 0,
    limit: ITEMS_PER_PAGE,
    sort_field: configManagerFields.modified,
    sort_direction: SortOrder.desc
};
